var _rect, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.826172,
    width: 40.117,
    height: 40.1742,
    rx: 20.0585,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0585 12.6852C22.7169 12.6852 23.0794 12.6852 24.1669 12.6852C25.1336 12.6852 25.6169 12.9272 25.9794 13.0482C26.4628 13.2903 26.8253 13.4113 27.1878 13.7743C27.5503 14.1373 27.7919 14.5003 27.9128 14.9843C28.0336 15.3474 28.1544 15.8314 28.2753 16.7994C28.2753 17.8885 28.2753 18.1305 28.2753 20.9137C28.2753 23.6968 28.2753 23.9388 28.2753 25.0279C28.2753 25.996 28.0336 26.48 27.9128 26.843C27.6711 27.327 27.5503 27.69 27.1878 28.0531C26.8253 28.4161 26.4628 28.6581 25.9794 28.7791C25.6169 28.9001 25.1336 29.0211 24.1669 29.1421C23.0794 29.1421 22.8377 29.1421 20.0585 29.1421C17.2794 29.1421 17.0377 29.1421 15.9502 29.1421C14.9835 29.1421 14.5002 28.9001 14.1377 28.7791C13.6543 28.5371 13.2918 28.4161 12.9293 28.0531C12.5668 27.69 12.3251 27.327 12.2043 26.843C12.0835 26.48 11.9626 25.996 11.8418 25.0279C11.8418 23.9388 11.8418 23.6968 11.8418 20.9137C11.8418 18.1305 11.8418 17.8885 11.8418 16.7994C11.8418 15.8314 12.0835 15.3474 12.2043 14.9843C12.446 14.5003 12.5668 14.1373 12.9293 13.7743C13.2918 13.4113 13.6543 13.1692 14.1377 13.0482C14.5002 12.9272 14.9835 12.8062 15.9502 12.6852C17.0377 12.6852 17.4002 12.6852 20.0585 12.6852ZM20.0585 10.8701C17.2794 10.8701 17.0377 10.8701 15.9502 10.8701C14.8627 10.8701 14.1377 11.1121 13.5335 11.3541C12.9293 11.5962 12.3251 11.9592 11.721 12.5642C11.1168 13.1692 10.8751 13.6533 10.5126 14.3793C10.271 14.9843 10.1501 15.7104 10.0293 16.7994C10.0293 17.8885 10.0293 18.2515 10.0293 20.9137C10.0293 23.6968 10.0293 23.9388 10.0293 25.0279C10.0293 26.117 10.271 26.843 10.5126 27.448C10.7543 28.0531 11.1168 28.6581 11.721 29.2631C12.3251 29.8682 12.8085 30.1102 13.5335 30.4732C14.1377 30.7152 14.8627 30.8362 15.9502 30.9572C17.0377 30.9572 17.4002 30.9572 20.0585 30.9572C22.7169 30.9572 23.0794 30.9572 24.1669 30.9572C25.2544 30.9572 25.9794 30.7152 26.5836 30.4732C27.1878 30.2312 27.7919 29.8682 28.3961 29.2631C29.0003 28.6581 29.2419 28.1741 29.6044 27.448C29.8461 26.843 29.9669 26.117 30.0878 25.0279C30.0878 23.9388 30.0878 23.5758 30.0878 20.9137C30.0878 18.2515 30.0878 17.8885 30.0878 16.7994C30.0878 15.7104 29.8461 14.9843 29.6044 14.3793C29.3628 13.7743 29.0003 13.1692 28.3961 12.5642C27.7919 11.9592 27.3086 11.7172 26.5836 11.3541C25.9794 11.1121 25.2544 10.9911 24.1669 10.8701C23.0794 10.8701 22.8377 10.8701 20.0585 10.8701Z",
    fill: "url(#paint0_linear_216_815)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0585 15.7104C17.1585 15.7104 14.8627 18.0095 14.8627 20.9137C14.8627 23.8178 17.1585 26.117 20.0585 26.117C22.9586 26.117 25.2544 23.8178 25.2544 20.9137C25.2544 18.0095 22.9586 15.7104 20.0585 15.7104ZM20.0585 24.3019C18.246 24.3019 16.6752 22.8498 16.6752 20.9137C16.6752 19.0986 18.1252 17.5255 20.0585 17.5255C21.8711 17.5255 23.4419 18.9776 23.4419 20.9137C23.4419 22.7288 21.8711 24.3019 20.0585 24.3019Z",
    fill: "url(#paint1_linear_216_815)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3752 16.7994C26.0426 16.7994 26.5836 16.2577 26.5836 15.5894C26.5836 14.9211 26.0426 14.3793 25.3752 14.3793C24.7079 14.3793 24.1669 14.9211 24.1669 15.5894C24.1669 16.2577 24.7079 16.7994 25.3752 16.7994Z",
    fill: "url(#paint2_linear_216_815)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_216_815",
    x1: 20.0585,
    y1: 10.8701,
    x2: 20.0585,
    y2: 30.9572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5A34E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#F0516C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2A94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_216_815",
    x1: 20.0585,
    y1: 10.8701,
    x2: 20.0585,
    y2: 30.9572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5A34E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#F0516C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2A94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_216_815",
    x1: 20.0585,
    y1: 10.8701,
    x2: 20.0585,
    y2: 30.9572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5A34E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#F0516C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2A94"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.8e142e5aecf731ee25e23cd7f56d17dc.svg";
export { ForwardRef as ReactComponent };